<div class="xux-tabs-body p-0">
  <div class="date-period-calendar">
    <ul class="date-period-years">
      <li *ngFor="let year of years"
          [class.active]="year == value.year"
          (click)="selectYear(year)">
        {{year}}
      </li>
    </ul>

    <ul class="date-period-months">
        <li *ngFor="let month of months"
            [class.active]="value.month == month"
            (click)="selectMonth(month)"
            [class.invisible]="!value.year"
            [class.single]="months?.length === 1">
          {{month.name}}
        </li>
    </ul>

    <ul class="date-period-periods">
        <li  *ngFor="let period of periods" (click)="selectPeriod(period)"
             [class.active]="value.period === period"
             [class.hidden]="!value.month"
             [class.invisible]="!value.month">
          {{formatDate(period.dateStart, config.dateFormat.short_date_format)}} - {{formatDate(period.dateEnd, config.dateFormat.short_date_format, 1)}}
        </li>
    </ul>
  </div>
</div>
